var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/lodash/_getPrototype.js
// module id = qq0B
// module chunks = 1